import { toBooleanFromBit } from './productHomePageSectionHelpers';

export const mapProductHomePageSectionFromApi = (row) => {
  if (!row) return null;
  return {
    ProductHomePageSectionId: row.ProductHomePageSectionId ?? null,
    SectionName: row.SectionName || '',
    DisplayOrder: row.DisplayOrder ?? 0,
    IsActive: toBooleanFromBit(row.IsActive, true),
  };
};

export const buildProductHomePageSectionSavePayload = (data, userId) => ({
  ProductHomePageSectionId: data.ProductHomePageSectionId || null,
  SectionName: data.SectionName?.trim() || '',
  DisplayOrder: data.DisplayOrder ?? 0,
  IsActive: data.IsActive !== false && data.IsActive !== 0 ? 1 : 0,
  UserId: userId,
});
